import type { RoundState } from '@magic/slot';

export const freeSpinsRound: RoundState[] = [
    {
        index: 0,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L4',
                },
            ],
        ],
        paddingPositions: [15, 198, 83, 12, 15],
        gameType: 'basegame',
        anticipation: [0, 0, 1, 2, 3],
    },
    {
        index: 1,
        type: 'setTotalWin',
        amount: 0,
    },
    {
        index: 2,
        type: 'freeSpinTrigger',
        totalFs: 10,
        positions: [
            {
                reel: 0,
                row: 2,
            },
            {
                reel: 1,
                row: 1,
            },
            {
                reel: 4,
                row: 3,
            },
        ],
    },
    {
        index: 3,
        type: 'updateFreeSpin',
        amount: 0,
        total: 10,
    },
    {
        index: 4,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L1',
                },
            ],
        ],
        paddingPositions: [146, 15, 73, 160, 44],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 5,
        type: 'setTotalWin',
        amount: 0,
    },
    {
        index: 6,
        type: 'updateFreeSpin',
        amount: 1,
        total: 10,
    },
    {
        index: 7,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
            ],
            [
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
            ],
        ],
        paddingPositions: [143, 145, 169, 132, 89],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 8,
        type: 'winInfo',
        totalWin: 57780,
        wins: [
            {
                symbol: 'L4',
                kind: 3,
                win: 180,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 1,
                        row: 2,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 1,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 18,
                    globalMult: 1,
                    winWithoutMult: 180,
                    symbolMult: 7,
                },
            },
            {
                symbol: 'H5',
                kind: 5,
                win: 57600,
                positions: [
                    {
                        reel: 0,
                        row: 2,
                    },
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 2,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 1,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                    {
                        reel: 3,
                        row: 2,
                    },
                    {
                        reel: 3,
                        row: 3,
                    },
                    {
                        reel: 4,
                        row: 2,
                    },
                    {
                        reel: 4,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 288,
                    globalMult: 1,
                    winWithoutMult: 57600,
                    symbolMult: 10,
                },
            },
        ],
    },
    {
        index: 9,
        type: 'setWin',
        amount: 57780,
        winLevel: 9,
    },
    {
        index: 10,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 11,
        type: 'updateFreeSpin',
        amount: 2,
        total: 10,
    },
    {
        index: 12,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
            ],
        ],
        paddingPositions: [53, 153, 164, 27, 13],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 13,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 14,
        type: 'updateFreeSpin',
        amount: 3,
        total: 10,
    },
    {
        index: 15,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H2',
                },
            ],
        ],
        paddingPositions: [136, 118, 38, 1, 131],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 16,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 17,
        type: 'updateFreeSpin',
        amount: 4,
        total: 10,
    },
    {
        index: 18,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H1',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
            ],
        ],
        paddingPositions: [154, 91, 45, 135, 123],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 19,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 20,
        type: 'updateFreeSpin',
        amount: 5,
        total: 10,
    },
    {
        index: 21,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [181, 86, 52, 77, 3],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 22,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 23,
        type: 'updateFreeSpin',
        amount: 6,
        total: 10,
    },
    {
        index: 24,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L4',
                },
            ],
        ],
        paddingPositions: [178, 50, 130, 178, 173],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 25,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 26,
        type: 'updateFreeSpin',
        amount: 7,
        total: 10,
    },
    {
        index: 27,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H3',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [77, 115, 78, 177, 4],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 28,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 29,
        type: 'updateFreeSpin',
        amount: 8,
        total: 10,
    },
    {
        index: 30,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L2',
                },
            ],
        ],
        paddingPositions: [73, 108, 130, 42, 126],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 31,
        type: 'setTotalWin',
        amount: 57780,
    },
    {
        index: 32,
        type: 'updateFreeSpin',
        amount: 9,
        total: 10,
    },
    {
        index: 33,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H4',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 5,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [173, 77, 170, 54, 96],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 34,
        type: 'winInfo',
        totalWin: 24500,
        wins: [
            {
                symbol: 'H1',
                kind: 4,
                win: 24500,
                positions: [
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 1,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                    {
                        reel: 3,
                        row: 1,
                    },
                    {
                        reel: 3,
                        row: 2,
                    },
                    {
                        reel: 3,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 49,
                    globalMult: 1,
                    winWithoutMult: 24500,
                    symbolMult: 11,
                },
            },
        ],
    },
    {
        index: 35,
        type: 'setWin',
        amount: 24500,
        winLevel: 9,
    },
    {
        index: 36,
        type: 'setTotalWin',
        amount: 82280,
    },
    {
        index: 37,
        type: 'freeSpinEnd',
        amount: 82280,
        winLevel: 8,
    },
    {
        index: 38,
        type: 'finalWin',
        amount: 82280,
    },
];
